var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99023 12C1.99023 6.49756 6.49755 1.99024 12 1.99024V3.21951C7.14145 3.21951 3.2195 7.14146 3.2195 12C3.2195 16.8585 7.14145 20.722 12 20.7805C16.8585 20.722 20.7219 16.8585 20.7805 12C20.7219 7.14146 16.8585 3.21951 12 3.21951V1.99024C17.5024 1.99024 22.0097 6.49756 22.0097 12C22.0097 17.5024 17.5024 22.0098 12 22.0098C6.49755 22.0098 1.99023 17.5024 1.99023 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9171 10.4195H13.5805V7.08293C13.5805 6.67318 13.2293 6.38049 12.761 6.38049H11.239C10.7707 6.38049 10.4195 6.67318 10.4195 7.08293V10.4195H7.08293C6.67318 10.4195 6.38049 10.7707 6.38049 11.239V12.761C6.38049 13.2293 6.67318 13.5805 7.08293 13.5805H10.4195V16.9171C10.4195 17.2683 10.7707 17.6195 11.239 17.6195H12.761C13.2293 17.6195 13.5805 17.2683 13.5805 16.9171V13.5805H16.9171C17.2683 13.5805 17.6195 13.2293 17.6195 12.761V11.239C17.6195 10.7707 17.2683 10.4195 16.9171 10.4195Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconOn);
export default __webpack_public_path__ + "static/media/AddIconOn.16a0cdb9aef3763610015df55db91f86.svg";
export { ForwardRef as ReactComponent };